import { Box } from '@/UI/Box/Box';
import { Skeleton } from '@/UI/Skeleton/Skeleton';
import { TextArea } from '@/UI/TextArea/TextArea';
import { color } from '@/colors';
import { FlexCol } from '@/UI/styles';

function DesignAppPrompt({ id, value, onChange, isLoading, setIsEditingInputMetadata, error, helperText, disabled }) {
  const onPromptChange = (event) => {
    const updatedPrompt = event.target.value;
    onChange(id, { prompt: updatedPrompt });
  };

  return (
    <Box>
      {isLoading ? (
        <FlexCol
          sx={{
            width: '100%',
            height: '110px',
            border: `1px solid ${color.White64_T}`,
            borderRadius: 1,
            p: 2,
          }}
        >
          <Skeleton animation="wave" width="100%" height={14} />
          <Skeleton animation="wave" width="50%" height={14} />
          <Skeleton animation="wave" width="80%" height={14} />
          <Skeleton animation="wave" width="60%" height={14} />
        </FlexCol>
      ) : (
        <TextArea
          error={error}
          helperText={helperText}
          placeholder={value}
          fullWidth
          onFocus={() => setIsEditingInputMetadata(true)}
          onBlur={() => setIsEditingInputMetadata(false)}
          value={value}
          onChange={onPromptChange}
          minRows={4}
          maxRows={20}
          disabled={disabled}
          sx={{
            background: `${color.Black100}`,
            mt: 0,
            '& .MuiFormHelperText-root': {
              background: `none`,
              margin: 0,
              paddingLeft: 0,
              paddingTop: 0.5,
            },
          }}
        />
      )}
    </Box>
  );
}

export default DesignAppPrompt;
